/* istanbul ignore file */

/**
 * TODO: We simply don't need this. This is overthinking things. Disable the
 * app that customers are currently on in the Sidebar like we used to do in the
 * Good Old Days 🌸
 */

import { useRef } from "react";
import { useHistory } from "react-router-dom";

let hasAppliedBlocker = false;

// When a react-router <Link> is clicked, the href gets pushed into the history stack.
// This method ensures that if we're already on that page (or the page it redirects to),
// that we don't push a duplicate entry. If a duplicate gets pushed, the back button in
// the browser will keep us on the current page until it has been clicked enough times
// to actually go to the previous page.
export const useHistoryBlocker = (): void => {
  const history = useHistory();
  const currentLocation = useRef(location.pathname + location.search);
  const sideNavHrefs = useRef(new Set());
  const sideNavLinks = useRef(".gk-nav-item [data-qa='gk-router-nav-link']");
  const sideNavRedirectUrls = useRef<Record<string, string>>({});

  // Make sure we only add one event handler to the history object
  if (hasAppliedBlocker) return;
  hasAppliedBlocker = true;

  // Get a list of all the urls in the sidenav
  [...document.querySelectorAll(sideNavLinks.current)].forEach((el) => {
    sideNavHrefs.current.add(el.getAttribute("href"));
  });

  // Intercept each url change, and determine whether or not to allow it
  history.block((location, action): any => {
    const nextLocation = location.pathname + location.search;
    const prevLocation = currentLocation.current.split("?")[0];

    // If we are replacing a url from the side nav, track which url we redirect to, that way if
    // we are on the replaced url and click on the original url, we know not to push the state
    if (action === "REPLACE" && sideNavHrefs.current.has(prevLocation)) {
      sideNavRedirectUrls.current[prevLocation] = nextLocation;
    }

    // Don't push a new url into the history stack if we are already on that page
    if (action === "PUSH") {
      const isSameUrl = currentLocation.current === nextLocation;
      const redirectsToSameUrl =
        sideNavRedirectUrls.current[nextLocation] === prevLocation;
      if (isSameUrl || redirectsToSameUrl) {
        return false;
      }
    }

    currentLocation.current = nextLocation;
  });
};
